import React from 'react';

import PropTypes from 'prop-types';

import { ComplexButtonPanel, PopupBody, PopupBoxClose } from './styles';
import { LightDiskButton } from '../common/fromAuth/LightDiskButton/LightDiskButton';
import { PromoButton } from '../common/promo-button/PromoButton';

const getButtonType = (primaryButtonType) => {
    switch (primaryButtonType) {
        case 'link':
            return 'link';
        default:
            return 'button';
    }
};

const PromoComplexPopup = ({ popupRef = null, ...props }) => {
    return (
        <>
            {!props.withoutCloseButton && (
                <PopupBoxClose>
                    <LightDiskButton
                        onClick={() => {
                            if (props.handleClose) {
                                props.handleClose();
                            } else {
                                popupRef.current?.close();
                            }
                        }}
                        iconName="cross"
                        iconColor="mediumGray"
                        size="small"
                        type="button"
                        variant="tertiary"
                        raised={false}
                    />
                </PopupBoxClose>
            )}

            <PopupBody textCenter={props.textCenter} hasBottomPanel={props.hasBottomPanel} id={'promo-complex-popup'}>
                {props.children}
                {!props.withoutButton && (
                    <ComplexButtonPanel withoutButton={props.withoutButton}>
                        {props.primaryButtonText && (
                            <PromoButton
                                type={getButtonType(props.primaryButtonType)}
                                href={props.primaryButtonHref ? props.primaryButtonHref : null}
                                target={props.primaryButtonTarget ? props.primaryButtonTarget : null}
                                tabIndex={props.primaryButtonTabIndex ? props.primaryButtonTabIndex : null}
                                disabled={props.primaryButtonDisabled}
                                ref={props.formRef}
                                variant="primary"
                                caption={props.primaryButtonText}
                                onClick={(e) => {
                                    if (props.onPrimaryButtonClick) {
                                        props.onPrimaryButtonClick(e);
                                    }
                                }}
                            />
                        )}
                        {props.precheckPopupButtons}
                    </ComplexButtonPanel>
                )}
            </PopupBody>
        </>
    );
};

PromoComplexPopup.propTypes = {
    handleClose: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    withoutCloseButton: PropTypes.bool,
    textCenter: PropTypes.bool,
    hasBottomPanel: PropTypes.bool,
    withoutButton: PropTypes.bool,
    primaryButtonText: PropTypes.string,
    primaryButtonType: PropTypes.string,
    primaryButtonHref: PropTypes.string,
    primaryButtonTarget: PropTypes.string,
    primaryButtonTabIndex: PropTypes.string,
    primaryButtonForm: PropTypes.string,
    primaryButtonDisabled: PropTypes.bool,
    onPrimaryButtonClick: PropTypes.func,
};

export default PromoComplexPopup;
